import { useContext } from 'react';
import { ServerRecognitionContext } from 'src/contexts/ServerRecognitionContext';

export const useServerRecognition = () => useContext(ServerRecognitionContext);

export { RECOGNITION_SAMPLE_TYPE } from 'src/contexts/ServerRecognitionContext';
